import axiosInstance from '../Services/AxiosInstance';



export const mainPhotosFeedpagelist = async (userType, sortingType, offSet, usertoken, isloggedin, parsedRehuntedPost) => {



  try {
    const payload = {
      "userType": userType,
      "sortingType": sortingType,
      "offSet": offSet,
      ...(isloggedin && parsedRehuntedPost && sortingType == "by_recent_photos" && { rehuntedPhoto: parsedRehuntedPost }),
    };



    const url = isloggedin
      ? `/photo/list`
      : `/photo/list_photo_for_landing`;

    const response = await axiosInstance.post(url, payload);

    return response;
  } catch (error) {

    throw error;
  }
};







export const fetchProfileAndUpvotePhotos = async (userType, FilterValue, offSet, usertoken, UpvotePhotoState) => {
  try {
    const payload = {
      userType: userType,
      sortingType: FilterValue || "by_recent_photos",
      offSet: offSet
    };


    const url = UpvotePhotoState
      ? `/photo/list_upvoted_photo`
      : `/photo/list`;

    const response = await axiosInstance.post(url, payload);
    return response
  } catch (error) {
    throw error;
  }
};



export const ParticipateUsersPhotosList = async (offSet, usertoken,) => {
  try {
    const payload = {
      "offSet": offSet
    };



    const url = `photo/list_participating_members`


    const response = await axiosInstance.post(url, payload);

    return response;
  } catch (error) {

    throw error;
  }
};



export const bootApi = async (photoId, postedDate) => {
  try {
    const payload = {
      photoId,
      postedDate
    }
    const url = `photo/boostWeeklyPhotos`

    const response = await axiosInstance.post(url, payload);

    return response;
  } catch (error) {

    throw error;
  }
};


export const NotifyApi = async (photoId, photoMemberId, setIsNotify, setIsLoading) => {
  setIsLoading(true)
  try {
    const payload = {
      photoId,
      photoMemberId
    }
    const url = `notify/comingNextPhotos`

    const response = await axiosInstance.post(url, payload);
    setIsNotify(true)
    setIsLoading(false)
    return response;
  } catch (error) {
    setIsLoading(false)
    throw error;
  }
};


export const trackPhotoViews = async (photoID) => {

  try {
    const payload = {
      photoID,
    }
    const url = `photo/updateViewedPhotos`

    const response = await axiosInstance.post(url, payload);

    return response;
  } catch (error) {

    throw error;
  }
};